import { render, staticRenderFns } from "./DictamenGratuito.vue?vue&type=template&id=2551d5e2&"
import script from "./DictamenGratuito.vue?vue&type=script&lang=js&"
export * from "./DictamenGratuito.vue?vue&type=script&lang=js&"
import style0 from "./DictamenGratuito.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports